import React, { useEffect, useState } from "react";
import LoggedNav from "../components/LoggedNav";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { RiArrowLeftSLine } from "react-icons/ri";
import $ from "jquery";
import { Formik, ErrorMessage } from "formik";
import visa from "../images/icons/visa.png";
import master from "../images/icons/master.png";
import discover from "../images/icons/discover.png";
import { callErrorApi } from "../errorHandle/callErrorApi";

function cc_format(value) {
  const v = value
    .replace(/\s+/g, "")
    .replace(/[^0-9]/gi, "")
    .substr(0, 16);
  const parts = [];
  for (let i = 0; i < v.length; i += 4) {
    parts.push(v.substr(i, 4));
  }
  return parts.length > 1 ? parts.join(" ") : value;
}

function AddNewCard(props) {
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    name_on_card: "",
    card_number: "",
    exp_month: "",
    exp_year: "",
    cvv: "",
    billing_address: {
      line1: "",
      city: "",
      state: "",
      postal_code: "",
      country_code: "",
    },
    vault_id: "",
  });
  const [loading, setLoading] = useState(true);
  const [cardExists, setCardExists] = useState(false);

  // Set meta tags (as in your code)
  useEffect(() => {
    document.title = `Add Card Details | CHEF REPUBLIC`;
    [
      ["meta[name='title']", "content", "Add Card Details | CHEF REPUBLIC"],
      ["meta[name='description']", "content", ""],
      ["meta[property='og:title']", "content", "Add Card Details | CHEF REPUBLIC"],
      ["meta[property='og:description']", "content", ""],
      ["meta[property='twitter:title']", "content", "Add Card Details | CHEF REPUBLIC"],
      ["meta[property='twitter:description']", "content", ""],
    ].forEach(([selector, attr, val]) => {
      const tag = document.querySelector(selector);
      if (tag) tag.setAttribute(attr, val);
    });
  }, []);

  // Fetch card details from vault on mount
  useEffect(() => {
    async function fetchCard() {
      setLoading(true);
      try {
        const user_id = localStorage.getItem("logged_user_id");
        if (!user_id) {
          setLoading(false);
          return;
        }
        const resp = await fetch(
          `${process.env.REACT_APP_BASE_URL}user/fetch_card_from_vault`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ user_id }),
          }
        );
        const data = await resp.json();
        if (data.status && data.data) {
          const card = data.data;
          setInitialValues({
            name_on_card: card.name_on_card || "",
            card_number: card.card_number ? cc_format(card.card_number) : "",
            exp_month: card.exp_month || "",
            exp_year: card.exp_year || "",
            cvv: "", // never prefill CVV
            billing_address: {
              line1: card.billing_address?.line1 || "",
              city: card.billing_address?.city || "",
              state: card.billing_address?.state || "",
              postal_code: card.billing_address?.postal_code || "",
              country_code: card.billing_address?.country_code || "",
            },
            vault_id: card.vault_id || "",
          });
          setCardExists(true);
        } else {
          setCardExists(false);
        }
      } catch (error) {
        callErrorApi(
          `catch_error: ${process.env.REACT_APP_BASE_URL}user/fetch_card_from_vault`,
          localStorage.getItem("owner"),
          error
        );
      } finally {
        setLoading(false);
      }
    }
    fetchCard();
  }, []);

  function containsSpecialChars(str, reg = null) {
    // eslint-disable-next-line
    var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (reg) {
      specialChars = reg;
    }
    return specialChars.test(str);
  }

  function validateCVV(value) {
    if (value && isNaN(value)) {
      return "Invalid CVV";
    }
    return undefined;
  }

  function validateCardNumber(value) {
    if (value && isNaN(value.replaceAll(" ", ""))) {
      return "Invalid Card Number";
    }
    return undefined;
  }

  if (loading) {
    return (
      <>
        <LoggedNav customer={props.customer} />
        <div className="container my-5 text-center">
          <div className="spinner-border text-primary" />
        </div>
      </>
    );
  }

  return (
    <>
      <LoggedNav customer={props.customer} />
      <div className="container my-4">
        {isMobile ? null : (
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li
                className="breadcrumb-item active"
                style={{ cursor: "pointer" }}
                aria-current="page"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <span className="pe-2 h4">
                  <RiArrowLeftSLine />
                </span>
                Go Back
              </li>
            </ol>
          </nav>
        )}
        <div className="container d-flex justify-content-center align-items-center">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validate={values => {
              const d = new Date();
              const errors = {};
              if (!values.name_on_card) {
                errors.name_on_card = "Card Holder Name is Required";
              } else if (containsSpecialChars(values.name_on_card)) {
                errors.name_on_card = "Special Character not allowed";
              }
              if (!values.card_number) {
                errors.card_number = "Card Number is Required";
              } else if (containsSpecialChars(values.card_number)) {
                errors.card_number = "Special Character not allowed";
              } else if (validateCardNumber(values.card_number)) {
                errors.card_number = "Invalid Card Number";
              }
              if (!values.exp_month) {
                errors.exp_month = "Expiry Month is Required";
                // eslint-disable-next-line
              } else if (
                containsSpecialChars(
                  values.exp_month,
                  /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>?~]/
                )
              ) {
                errors.exp_month = "Special Character not allowed";
              } else if (isNaN(values.exp_month)) {
                errors.exp_month = "Expiry Month is Invalid";
              } else if (parseInt(values.exp_month) > 12) {
                errors.exp_month = "Expiry Month cannot be more than 12";
              } else if (parseInt(values.exp_month) === 0) {
                errors.exp_month = "Expiry Month cannot be 00";
              }
              if (!values.exp_year) {
                errors.exp_year = "Expiry Year is Required";
                // eslint-disable-next-line
              } else if (
                containsSpecialChars(
                  values.exp_year,
                  /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>?~]/
                )
              ) {
                errors.exp_year = "Special Character not allowed";
              } else if (isNaN(values.exp_year)) {
                errors.exp_year = "Expiry Year is Invalid";
              } else if (
                parseInt(values.exp_year) < parseInt(d.getFullYear().toString())
              ) {
                errors.exp_year = "Card is Expired";
              } else if (
                parseInt(d.getFullYear().toString()) ===
                  parseInt(values.exp_year) &&
                parseInt(values.exp_month) === d.getMonth() + 1
              ) {
                errors.exp_month = "Card is about to expire";
              } else if (
                parseInt(d.getFullYear().toString()) ===
                  parseInt(values.exp_year) &&
                parseInt(values.exp_month) < d.getMonth() + 1
              ) {
                errors.exp_month = "Card is Expired";
              }
              if (!values.cvv) {
                errors.cvv = "CVV is Required";
              } else if (containsSpecialChars(values.cvv)) {
                errors.cvv = "Special Character not allowed";
              } else if (validateCVV(values.cvv)) {
                errors.cvv = "Invalid CVV";
              }
              // Billing address validation
              if (!values.billing_address.line1) {
                errors.billing_address = { ...errors.billing_address, line1: "Address is required" };
              }
              if (!values.billing_address.city) {
                errors.billing_address = { ...errors.billing_address, city: "City is required" };
              }
              if (!values.billing_address.state) {
                errors.billing_address = { ...errors.billing_address, state: "State is required" };
              }
              if (!values.billing_address.postal_code) {
                errors.billing_address = { ...errors.billing_address, postal_code: "Postal code is required" };
              }
              if (!values.billing_address.country_code) {
                errors.billing_address = { ...errors.billing_address, country_code: "Country code is required" };
              }
              return errors;
            }}
            onSubmit={async (values, { setSubmitting, setFieldError, setStatus }) => {
              try {
                const url = cardExists
                  ? `${process.env.REACT_APP_BASE_URL}user/update_card_in_vault`
                  : `${process.env.REACT_APP_BASE_URL}user/add_card_to_vault`;
                const body = {
                  vault_id: values.vault_id,
                  name_on_card: values.name_on_card,
                  card_number: values.card_number.replaceAll(" ", ""),
                  exp_month: values.exp_month,
                  exp_year: values.exp_year,
                  cvv: values.cvv,
                  billing_address: {
                    line1: values.billing_address.line1,
                    city: values.billing_address.city,
                    state: values.billing_address.state,
                    postal_code: values.billing_address.postal_code,
                    country_code: values.billing_address.country_code,
                  },
                };
                const response = await fetch(url, {
                  method: "POST",
                  headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(body),
                });
                const res_json = await response.text();
                const data = JSON.parse(res_json);
                if (data.status === true) {
                  localStorage.setItem("card_added", 1);
                  setSubmitting(false);
                  navigate("/profile");
                } else {
                  callErrorApi(
                    `response_error: ${url}`,
                    localStorage.getItem("owner"),
                    data
                  );
                  $(".error-msg").html(data.message || "Something went wrong. Please try Again");
                  setSubmitting(false);
                }
              } catch (error) {
                callErrorApi(
                  `catch_error: ${cardExists
                    ? `${process.env.REACT_APP_BASE_URL}user/update_card_in_vault`
                    : `${process.env.REACT_APP_BASE_URL}user/add_card_to_vault`
                  }`,
                  localStorage.getItem("owner"),
                  error
                );
                setSubmitting(false);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <div
                className="card pb-3"
                style={{
                  width: "388px",
                  minHeight: "650px",
                  borderRadius: "20px",
                  boxShadow: "0,0,0,grba(0,0,0,0.2)",
                }}
              >
                <div className="card-header border-0 bg-transparent">
                  <h4 className="mx-auto my-4" style={{ textAlign: "center" }}>
                    {cardExists ? "Update Card" : "Add new card"}
                  </h4>
                  <h6 className="mx-auto my-4" style={{ textAlign: "center" }}>
                    You will not be charged right now
                  </h6>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="border p-1 border-1 m-1 d-flex justify-content-center align-items-center">
                    <img src={visa} width={50} alt="" />
                  </div>
                  <div className="border p-1 border-1 m-1 d-flex justify-content-center align-items-center">
                    <img src={master} width={50} alt="" />
                  </div>
                  <div className="border p-1 border-1 m-1 d-flex justify-content-center align-items-center">
                    <img src={discover} width={50} alt="" />
                  </div>
                </div>
                <div className="card-body">
                  <form id="addCard" onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <input
                        placeholder="Name on Card"
                        type="text"
                        name="name_on_card"
                        className={
                          errors.name_on_card
                            ? "form-control shadow-none invalid"
                            : "form-control shadow-none"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name_on_card}
                      />
                      <ErrorMessage name="name_on_card">
                        {(msg) => <h6 className="error-msg">{msg}</h6>}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <input
                        placeholder="Card Number"
                        type="text"
                        maxLength={19}
                        minLength={18}
                        name="card_number"
                        className={
                          errors.card_number
                            ? "form-control shadow-none invalid"
                            : "form-control shadow-none"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={cc_format(values.card_number)}
                      />
                      <ErrorMessage name="card_number">
                        {(msg) => <h6 className="error-msg">{msg}</h6>}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <input
                        placeholder="Expiry Month (MM)"
                        type="text"
                        maxLength={2}
                        minLength={2}
                        name="exp_month"
                        className={
                          errors.exp_month
                            ? "form-control shadow-none invalid"
                            : "form-control shadow-none"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.exp_month}
                      />
                      <ErrorMessage name="exp_month">
                        {(msg) => <h6 className="error-msg">{msg}</h6>}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <input
                        placeholder="Expiry Year (YYYY)"
                        type="text"
                        maxLength={4}
                        minLength={4}
                        name="exp_year"
                        className={
                          errors.exp_year
                            ? "form-control shadow-none invalid"
                            : "form-control shadow-none"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.exp_year}
                      />
                      <ErrorMessage name="exp_year">
                        {(msg) => <h6 className="error-msg">{msg}</h6>}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <input
                        placeholder="CVV"
                        type="text"
                        maxLength="3"
                        minLength="3"
                        name="cvv"
                        className={
                          errors.cvv
                            ? "form-control shadow-none invalid"
                            : "form-control shadow-none"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.cvv}
                      />
                      <ErrorMessage name="cvv">
                        {(msg) => <h6 className="error-msg">{msg}</h6>}
                      </ErrorMessage>
                    </div>
                    {/* Billing Address Fields */}
                    <div className="mb-3">
                      <input
                        placeholder="Billing Address Line 1"
                        type="text"
                        name="billing_address.line1"
                        className={
                          errors.billing_address?.line1
                            ? "form-control shadow-none invalid"
                            : "form-control shadow-none"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.billing_address.line1}
                      />
                      <ErrorMessage name="billing_address.line1">
                        {(msg) => <h6 className="error-msg">{msg}</h6>}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <input
                        placeholder="City"
                        type="text"
                        name="billing_address.city"
                        className={
                          errors.billing_address?.city
                            ? "form-control shadow-none invalid"
                            : "form-control shadow-none"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.billing_address.city}
                      />
                      <ErrorMessage name="billing_address.city">
                        {(msg) => <h6 className="error-msg">{msg}</h6>}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <input
                        placeholder="State"
                        type="text"
                        name="billing_address.state"
                        className={
                          errors.billing_address?.state
                            ? "form-control shadow-none invalid"
                            : "form-control shadow-none"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.billing_address.state}
                      />
                      <ErrorMessage name="billing_address.state">
                        {(msg) => <h6 className="error-msg">{msg}</h6>}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <input
                        placeholder="Postal Code"
                        type="text"
                        name="billing_address.postal_code"
                        className={
                          errors.billing_address?.postal_code
                            ? "form-control shadow-none invalid"
                            : "form-control shadow-none"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.billing_address.postal_code}
                      />
                      <ErrorMessage name="billing_address.postal_code">
                        {(msg) => <h6 className="error-msg">{msg}</h6>}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <input
                        placeholder="Country Code (e.g. US)"
                        type="text"
                        name="billing_address.country_code"
                        className={
                          errors.billing_address?.country_code
                            ? "form-control shadow-none invalid"
                            : "form-control shadow-none"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.billing_address.country_code}
                      />
                      <ErrorMessage name="billing_address.country_code">
                        {(msg) => <h6 className="error-msg">{msg}</h6>}
                      </ErrorMessage>
                    </div>
                    <h6 className="text-center error-msg validation p-0">{""}</h6>
                    <div className="mb-3 text-center">
                      <button
                        type="submit"
                        className="mb-4 btn-orange w-100"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                          ""
                        )}{" "}
                        {cardExists ? "Update Card" : "Add New Card"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

export default AddNewCard;